const Import = require('../_import_' + process.env.NODE_ENV)
export default [
  {
    path: '/h5/guide',
    component: Import('guide/index'),
    name: 'guideIndex',
    meta: { title: '公证指南' }
  },
  {
    path: '/h5/topic/:topicId',
    component: Import('guide/topic'),
    name: 'topic',
    meta: { title: '专题' }
  },
  {
    path: '/h5/article/:articleId',
    component: Import('guide/article'),
    name: 'article',
    meta: { title: '文章详情' }
  }
]



// WEBPACK FOOTER //
// ./src/router/model/guide.js